import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useCallback, useMemo } from 'react';
import classNames from 'classnames/bind';
import { LockIcon } from "./components/LockIcon";
import { CheckboxIcon } from "./components/CheckboxIcon";
import forCheckboxStyle from "./checkbox.pcss";
import forToggleStyle from "./toggle.pcss";
import { PreloadIcon } from "./components/PreloadIcon";
import { spreadDangerousChildren } from "../../utils/spreadDangerousChildren";
var checkboxClassNames = classNames.bind(forCheckboxStyle);
var toggleClassNames = classNames.bind(forToggleStyle);
export var MultipleChoice = /*#__PURE__*/memo(function (_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    label = _ref.label,
    labelwrap = _ref.labelwrap,
    name = _ref.name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return false;
    } : _ref$onChange,
    radioVariant = _ref.radioVariant,
    size = _ref.size,
    toggle = _ref.toggle,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    color = _ref.color,
    rightSideNode = _ref.rightSideNode,
    testName = _ref.testName,
    isError = _ref.isError,
    dataName = _ref.dataName;
  var checkboxStyle = useMemo(function () {
    return checkboxClassNames('checkbox', {
      'checkbox--disabled': disabled,
      'checkbox--label-wrap': label && labelwrap,
      'checkbox--label-wrap-small': size === 'small' && label && labelwrap && !radioVariant,
      'checkbox--radio-small': size !== 'big' && radioVariant === 'default'
    });
  }, [disabled, radioVariant, size, labelwrap, label]);
  var toggleStyle = useMemo(function () {
    return toggleClassNames('toggle', {
      'toggle--disabled': disabled
    });
  }, [disabled]);
  var inputClasses = useMemo(function () {
    return toggle ? toggleClassNames('toggle__input') : checkboxClassNames('checkbox__input');
  }, [toggle]);
  var inputType = useMemo(function () {
    return radioVariant ? 'radio' : 'checkbox';
  }, [radioVariant]);
  var handleChange = useCallback(function (event) {
    onChange(event);
  }, [onChange]);
  var radioColorStyle = color ? {
    backgroundColor: "".concat(color)
  } : undefined;
  var checkboxColor = useMemo(function () {
    if (isError) {
      return '#cc2c00';
    }
    if (disabled) {
      return '#A7ABB0';
    }
    return '#13171b';
  }, [isError, disabled]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    React.createElement("label", {
      className: toggle ? toggleStyle : checkboxStyle,
      "data-component": testName,
      "data-name": dataName,
      "data-t-id": "inputs-MultipleChoice"
    }, /*#__PURE__*/React.createElement("input", {
      checked: checked,
      className: inputClasses,
      disabled: disabled,
      name: name,
      onChange: handleChange,
      type: inputType,
      value: value
    }), !toggle && (radioVariant === 'default' || radioVariant === 'color') && /*#__PURE__*/React.createElement(React.Fragment, null, radioVariant === 'default' && /*#__PURE__*/React.createElement("div", {
      className: checkboxClassNames('checkbox__border', 'checkbox__border--radio', {
        'checkbox__border--radio-checked': checked,
        'checkbox__border--radio-small': size !== 'big',
        'checkbox__border--radio-checked-small': size !== 'big' && checked
      })
    }), radioVariant === 'color' && /*#__PURE__*/React.createElement("div", {
      className: checkboxClassNames('checkbox__border', 'checkbox__border--radio', {
        'checkbox__border--radio-checked': checked,
        'checkbox__border--radio-big': size === 'big' && !checked,
        'checkbox__border--radio-checked-big': size === 'big' && checked
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: checkboxClassNames('checkbox__radio-color'),
      style: radioColorStyle
    }))), !toggle && !radioVariant && /*#__PURE__*/React.createElement("span", {
      className: checkboxClassNames('checkbox__icon')
    }, /*#__PURE__*/React.createElement(CheckboxIcon, {
      checked: checked,
      fill: checkboxColor
    })), toggle && !radioVariant && /*#__PURE__*/React.createElement("div", {
      className: toggleClassNames('toggle__border')
    }, /*#__PURE__*/React.createElement("div", {
      className: toggleClassNames('toggle__icon')
    }), isLoading && /*#__PURE__*/React.createElement("div", {
      className: toggleClassNames('toggle__preloader-wrapper')
    }, /*#__PURE__*/React.createElement("span", {
      className: toggleClassNames('toggle__preloader')
    }, /*#__PURE__*/React.createElement(PreloadIcon, {
      color: checked ? '#d58e35' : '#313031'
    }))), disabled && /*#__PURE__*/React.createElement("div", {
      className: toggleClassNames('toggle__lock')
    }, /*#__PURE__*/React.createElement(LockIcon, {
      fill: "#5a5e62"
    }))), (label || rightSideNode) && /*#__PURE__*/React.createElement("div", {
      className: checkboxClassNames('checkbox__label', {
        'checkbox__label--wrap': labelwrap,
        'checkbox__label--small': size === 'small',
        'checkbox__label--disabled': disabled,
        'label--toggle': toggle,
        'checkbox__label--radio-big': radioVariant && size === 'big',
        'checkbox__label--error': !radioVariant && isError
      })
    }, label && /*#__PURE__*/React.createElement("span", _extends({
      className: checkboxClassNames({
        'checkbox__text--small': size === 'small' && rightSideNode,
        'checkbox__text--big': size === 'big' && rightSideNode
      })
    }, spreadDangerousChildren(label))), !!rightSideNode && rightSideNode))
  );
});